module.exports = __webpack_public_path__ + "media/images/lb/553-9c2c8883e6ce6c782dd88ba3f33b341e.svg";